import Vue from 'vue'
import VueRouter from 'vue-router'
import { HeaderType } from '@/model/HeaderType'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/ringZone'
  },
  {
    path: '/ringZone',
    name: 'ring-zone',
    component: () => import(/* webpackChunkName: "ring-zone" */ /* webpackPreload: true */'@/views/ring-zone/'),
    meta: {
      title: '彩铃专区',
      common: true,
      finishBack: true,
      keepAlive: true,
      home: true,
      name: '彩铃专区首页',
      pageIndex: 1
    }
  },
  {
    path: '/recommond',
    name: 'recommond-list',
    component: () => import(/* webpackChunkName: "recommond-list" */'@/views/recommond/'),
    meta: { title: '每日推荐', common: true, keepAlive: true, finishBack: true, home: true, name: '每日推荐', pageIndex: 2 }
  },
  {
    path: '/category',
    name: 'category',
    component: () => import(/* webpackChunkName: "category" */'@/views/category/'),
    meta: { title: '视频分类', common: true, name: '视频彩铃分类页' }
  },
  {
    path: '/myringstone',
    name: 'myringstone',
    component: () => import(/* webpackChunkName: "myringstone" */'@/views/myringstone/'),
    meta: { title: '铃声', finishBack: true, name: '我的铃声页', pageIndex: 200 }
  },
  {
    path: '/details',
    name: 'details',
    component: () => import(/* webpackChunkName: "details" */ /* webpackPreload: true */'@/views/video-details/'),
    meta: { title: '视频彩铃', name: '视频彩铃详情页', pageIndex: 5 }
  },
  {
    path: '/search',
    name: 'search-page',
    component: () => import(/* webpackChunkName: "search-page" */'@/views/search'),
    meta: { title: '彩铃搜索', keepAlive: true, common: true, name: '彩铃搜索', pageIndex: 2 }
  },
  {
    path: '/ringtone-topic/:id',
    name: 'ringtone-topic',
    component: () => import(/* webpackChunkName: "ringtone-topic" */ /* webpackPreload: true */'@/views/ringtone-topic'),
    meta: { title: '彩铃专题', keepAlive: true, common: true, name: '彩铃专题', pageIndex: 4 }
  },
  {
    path: '/ringtone-topic-preview/:id',
    name: 'ringtone-topic-preview',
    component: () => import(/* webpackChunkName:"ringtone-topic-preview" */'@/views/ringtone-topic/preview.vue'),
    meta: { title: '彩铃专题预览', common: true, name: '彩铃专题预览', pageIndex: 4 }
  },
  {
    path: '/personal',
    name: 'personal',
    component: () => import(/* webpackChunkName:"personal" */'@/views/personal'),
    meta: { title: '个人中心', common: true, name: '个人中心', pageIndex: 5 }
  },
  {
    path: '/login-acount',
    name: 'login-acount',
    component: () => import(/* webpackChunkName:"login-acount" */'@/views/video-order-page/login'),
    meta: { title: '账号登录', common: true, name: '个人中心登录', pageIndex: 6 }
  },
  {
    path: '/login-choice',
    name: 'login-choice',
    component: () => import(/* webpackChunkName:"login-choice" */'@/views/video-order-page/login-choice'),
    meta: { title: '账号登录', common: true, name: '账号登录', pageIndex: 6 }
  },
  {
    path: '/inputphone-oneclick',
    name: 'inputphone-oneclick',
    component: () => import(/* webpackChunkName:"inputphone-oneclick" */'@/views/video-order-page/input-phone-with-oneclick'),
    meta: { title: '账号登录', common: true, name: '账号登录', pageIndex: 6 }
  },
  {
    path: '/verification-code',
    name: 'verification-code',
    component: () => import(/* webpackChunkName:"verification-code" */'@/views/video-order-page/verification-code'),
    meta: { title: '输入验证码', common: true, name: '输入验证码', pageIndex: 9, isPush: true }
  },
  {
    path: '/qa',
    name: 'qaIndex',
    component: () => import(/* webpackChunkName:"qaIndex" */'@/views/qa/new-qa'),
    meta: { title: '帮助与反馈', keepAlive: true, common: true, name: '帮助与反馈页', pageIndex: 10 }
  },
  // {
  //   path: '/new-qa',
  //   name: 'qaIndex',
  //   component: () => import(/* webpackChunkName:"newqaIndex" */'@/views/qa/new-qa'),
  //   meta: { title: '帮助与反馈', keepAlive: true, common: true, name: '帮助与反馈页', pageIndex: 10 }
  // },
  {
    path: '/qa-details',
    name: 'qa-details',
    component: () => import(/* webpackChunkName:"qa-details" */'@/views/qa-details/'),
    meta: { title: '帮助与反馈', common: true, name: '帮助与反馈页', pageIndex: 11 }
  },
  {
    path: '/rule-list',
    name: 'rule-list',
    component: () => import(/* webpackChunkName:"rule-list" */'@/views/rule-list/'),
    meta: { title: '资费公示', common: true, name: '资费公示', pageIndex: 11 }
  },
  {
    path: '/purchased-list',
    name: 'purchased-list',
    component: () => import(/* webpackChunkName:"purchased-list" */'@/views/purchased-list/'),
    meta: { title: '彩铃管理', common: true, name: '视频彩铃管理页', pageIndex: 201 }
  },
  {
    path: '/rankList',
    name: 'rankList',
    component: () => import(/* webpackChunkName:"rankList" */'@/views/ringback-rank/'),
    meta: { title: '', common: true, finishBack: true, whiteIcon: true, name: '音频彩铃排行榜' }
  },
  {
    path: '/test',
    name: 'testList',
    component: () => import(/* webpackChunkName:"testList" */'@/views/test/'),
    meta: { title: '', common: true, finishBack: true, whiteIcon: true, name: '音频彩铃排行榜' }
  },
  {
    path: '/favorite',
    name: 'favorite',
    component: () => import(/* webpackChunkName:"favorite" */'@/views/favorite-rings/'),
    meta: { title: '收藏铃声', name: '收藏铃声页', pageIndex: 201 }
  },
  {
    path: '/introduce-video',
    name: 'introduce-video',
    component: () => import(/* webpackChunkName:"introduce-video" */'@/views/introduce-video/'),
    meta: { title: '彩铃介绍', common: false, name: '彩铃介绍页', pageIndex: 6 }
  },
  {
    path: '/policy-telecom',
    name: 'policy-telecom',
    component: () => import(/* webpackChunkName:"policy-telecom" */'@/views/document/policy-telecom.vue'),
    meta: { title: '爱音乐公司隐私政策', common: true, name: '爱音乐公司隐私政策', pageIndex: 12 }
  },
  {
    path: '/agreement-telecom',
    name: 'agreement-telecom',
    component: () => import(/* webpackChunkName:"agreement-telecom" */'@/views/document/agreement-telecom.vue'),
    meta: { title: '互联网视频彩铃业务服务协议', common: true, name: '互联网视频彩铃业务服务协议', pageIndex: 12 }
  },
  {
    path: '/policy',
    name: 'policy-page',
    component: () => import(/* webpackChunkName:"policy-page" */'@/views/document/policy.vue'),
    meta: { title: '隐私政策', common: true, name: '隐私政策', pageIndex: 12 }
  },
  {
    path: '/agreement',
    name: 'agreement-page',
    component: () => import(/* webpackChunkName:"agreement-page" */'@/views/document/agreement.vue'),
    meta: { title: '用户协议', common: true, name: '用户协议', pageIndex: 12 }
  },
  {
    path: '/policy-info',
    name: 'policy-info',
    component: () => import(/* webpackChunkName:"policy-info" */'@/views/document/policy-info.vue'),
    meta: { title: '隐私政策', common: true, name: '隐私政策', pageIndex: 12 }
  },
  {
    path: '/agreement-info',
    name: 'agreement-info',
    component: () => import(/* webpackChunkName:"agreement-info" */'@/views/document/agreement-info.vue'),
    meta: { title: '用户协议', common: true, name: '用户协议', pageIndex: 12 }
  },
  {
    path: '/tab-home/:id',
    name: 'tab-home',
    component: () => import(/* webpackChunkName:"tab-home" */'@/views/tab-home/'),
    meta: { title: '视频彩铃二级', keepAlive: true, common: true, home: true, name: '视频彩铃二级', pageIndex: 4 }
  },
  {
    path: '/telecom',
    name: 'tab-details',
    component: () => import(/* webpackChunkName:"tab-purchased" */'@/views/purchased'),
    meta: { title: '电信投流', name: '电信投流', pageIndex: 5 }
  },
  {
    path: '/testpage',
    name: 'tab-details',
    component: () => import(/* webpackChunkName:"tab-testpage" */'@/views/purchased/testpage'),
    meta: { title: '电信投流', name: '电信投流', pageIndex: 5 }
  },
  {
    path: '/iframe',
    name: 'tab-details',
    component: () => import(/* webpackChunkName:"tab-testpage" */'@/views/test/iframe.vue'),
    meta: { title: '电信投流', name: '电信投流', pageIndex: 5 }
  },
  {
    path: '/page/:id',
    name: 'tab-page',
    component: () => import(/* webpackChunkName:"tab-page" */'@/views/purchased/page.vue'),
    meta: { title: '个性视频彩铃', name: '个性视频彩铃', pageIndex: 5 }
  },
  {
    path: '/page2/:id',
    name: 'tab-page2',
    component: () => import(/* webpackChunkName:"tab-page" */'@/views/purchased/page2.vue'),
    meta: { title: '个性视频彩铃', name: '个性视频彩铃', pageIndex: 5 }
  },
  {
    path: '/middle-page',
    name: 'middle-page',
    meta: { title: '视频彩铃', name: '视频彩铃', pageIndex: 2 },
    component: () => import('@/views/purchased/middlePage.vue')
  },
  {
    path: '/introduce-detail',
    name: 'introduce-detail',
    component: () => import(/* webpackChunkName:"tab-purchased2" */'@/views/purchased/detail'),
    meta: { title: '视频详情', name: '视频彩铃详情页', pageIndex: 6 }
  },
  {
    path: '/purchased-cucc',
    name: 'purchased-cucc',
    component: () => import(/* webpackChunkName:"tab-purchased-cucc" */'@/views/purchased-cucc/index'),
    meta: { title: '视频详情', name: '视频彩铃详情页', pageIndex: 6 }
  },
  // {
  //   path: '/investmentflow',
  //   name: 'investmentflow-telecom',
  //   component: () => import(/* webpackChunkName:"tab-purchased" */'@/views/purchased/index.vue'),
  //   meta: { title: '视频详情', name: '视频彩铃详情页', pageIndex: 6 }
  // },
  {
    path: '/order-url',
    name: 'order-url',
    component: () => import(/* webpackChunkName:"order-url" */'@/views/purchased-cucc/order-url'),
    meta: { title: '视频详情', name: '视频彩铃详情页', pageIndex: 6 }
  },
  {
    path: '/diy-details/:id',
    name: 'diy-details',
    component: () => import('@/views/diy/detail'),
    meta: { title: '视频彩铃', name: '视频彩铃', pageIndex: 5 }
  },
  {
    path: '/diy',
    name: 'diy-home',
    component: () => import('@/views/diy/index'),
    meta: { title: 'diy作品', common: true, name: 'diy作品', pageIndex: 4 }
  },
  {
    path: '/diy-list',
    name: 'diy-list',
    component: () => import('@/views/diy/diy-list'),
    meta: { title: 'diy作品', name: 'diy作品', pageIndex: 4 }
  },
  {
    path: '/diy-result',
    name: 'diy-result',
    component: () => import('@/views/diy/diy-result'),
    meta: { title: 'diy结果', name: 'diy结果', pageIndex: 8 }
  },
  {
    path: '/diy-input-phone',
    name: 'diy-input-phone',
    component: () => import('@/views/diy/input-phone'),
    meta: { title: '协议', name: '协议', pageIndex: 6 }
  }, {
    path: '/diy-verification-code',
    name: 'diy-verification-code',
    component: () => import('@/views/diy/verification-code'),
    meta: { title: '验证码', name: '协议', pageIndex: 7 }
  },
  {
    path: '/diy-agreement',
    name: 'diy-agreement',
    component: () => import('@/views/document/diy-agreement'),
    meta: { title: 'diy结果', name: 'diy结果', pageIndex: 6 }
  },
  {
    path: '/error-test',
    name: 'ErrorTest',
    component: () => import('@/views/error-test')
  },
  {
    path: '/topic-test',
    name: 'TopicTest',
    component: () => import('@/views/test/topic-test.vue')
  }, {
    path: '/test-page',
    name: 'TopicPage',
    component: () => import('@/views/test/test-page.vue')
  },
  {
    path: '/miguBJYH-ps',
    name: 'miguBJYH',
    meta: { title: '视频彩铃', name: '视频彩铃', pageIndex: 2, keepAlive: true },
    component: () => import('@/views/miguBJYH/index-00211PS.vue')
  }, {
    path: '/miguBJYH-pu',
    name: 'miguBJYH',
    meta: { title: '视频彩铃', name: '视频彩铃', pageIndex: 2, keepAlive: true },
    component: () => import('@/views/miguBJYH/index-00211PU.vue')
  },
  {
    path: '/miguBJYH',
    name: 'miguBJYH',
    meta: { title: '视频彩铃', name: '视频彩铃', pageIndex: 2, keepAlive: true },
    component: () => import('@/views/miguBJYH')
  }, {
    path: '/miguBJYH-song',
    name: 'miguBJYH-song',
    meta: { title: '歌曲试听', name: '歌曲试听', pageIndex: 2, keepAlive: true },
    component: () => import('@/views/miguBJYH/songList.vue')
  },
  {
    path: '/miguBJYH-ringzone/:id',
    name: 'miguBJYH-ringzone',
    meta: { title: '视频彩铃', name: '视频彩铃', pageIndex: 3 },
    component: () => import('@/views/miguBJYH/miguBJYH-ringzone.vue')
  },
  {
    path: '/miguBJYH-result',
    name: 'miguBJYH-result',
    meta: { title: '视频彩铃', name: '视频彩铃', pageIndex: 4 },
    component: () => import('@/views/miguBJYH/miguResult.vue')
  },
  {
    path: '/miguBJYH-detail',
    name: 'miguBJYH-detail',
    meta: { title: '视频彩铃', name: '视频彩铃', pageIndex: 4 },
    component: () => import('@/views/miguBJYH/detail.vue')
  },
  {
    path: '/topic-list-details/:id',
    name: 'topic-list-details',
    meta: { title: '视频彩铃', name: '视频彩铃', pageIndex: 2 },
    component: () => import('@/views/topic-list-details')
  },
  {
    path: '/backup-cw',
    name: 'backup-cw',
    meta: { title: '视频彩铃', name: '视频彩铃', pageIndex: 2 },
    component: () => import('@/views/backup/cw.vue')
  },
  {
    path: '/jsintheme',
    name: 'test-jsintheme',
    meta: { title: '视频彩铃', name: '视频彩铃', pageIndex: 2 },
    component: () => import('@/views/test/jsintheme.vue')
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior: () => ({ y: 0 })
})
const pathArr = ['details', 'preview', 'myringstone', 'favorite', 'introduce-video', 'order-page', 'test-preview', 'diy-details']

// 解决有开启状态栏头部 不需要滚动条的情况
const pathArr1 = ['login-choice', 'verification-code']

const pathArr2 = ['search-page', 'ring-zone', 'ringtone-topic', 'miguBJYH-ringzone'] // 不设置minHeight

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  // 公共头
  // hideheader或没有传默认不显示头部
  const { header_type: headerType, status_height: statusHeight, back } = to.query
  if ((back === '1' && to.name === 'ringtone-topic') || to.name === 'ring-zone' || to.name === 'recommond-list' || to.name === 'miguBJYH-ringzone' || to.name === 'ringtone-topic' || to.name === 'topic-list-details') {
    window.document.body.style.paddingTop = 0
    window.document.body.style.minHeight = '100vh'
    // window.document.body.style.height = 'auto'
  } else {
    if ((headerType !== HeaderType.HideHeader && !!headerType) || to.name === 'rankList') {
      if (pathArr.includes(to.name)) {
        window.document.body.style.paddingTop = 0
        window.document.body.style.minHeight = ''
        window.document.body.style.height = '100vh'
      } else {
        if (
          to.meta.home &&
          (headerType === HeaderType.TabHeader || headerType === HeaderType.QuickAppHeader) &&
          to.name !== 'rankList'
        ) {
          window.document.body.style.paddingTop = 0 + 'px'
          if (pathArr2.includes(to.name)) {
            window.document.body.style.height = '100vh'
            window.document.body.style.minHeight = 'auto'
          } else {
            window.document.body.style.minHeight = '100vh'
            window.document.body.style.height = 'auto'
          }
        } else {
          let h = statusHeight ? Number(statusHeight) + 50 : 32 + 50
          if (headerType === HeaderType.TabHeader || headerType === HeaderType.QuickAppHeader) {
            h = 50
          }

          window.document.body.style.paddingTop = h + 'px'

          if (pathArr2.includes(to.name)) {
            window.document.body.style.height = 'calc(100vh - ' + h + 'px)'
            window.document.body.style.minHeight = 'auto'
          } else {
            window.document.body.style.minHeight = 'calc(100vh - ' + h + 'px)'
            window.document.body.style.height = '100%'
          }
        }
      }
    }
  }

  // 解决有开启状态栏头部 不需要滚动条的情况
  if (pathArr1.includes(to.name)) {
    window.document.body.style.overflow = 'hidden'
  } else {
    window.document.body.style.overflow = ''
  }

  Vue.prototype.$height = statusHeight !== undefined ? Number(statusHeight) : 32
  next()
})

export default router
